import { DownloadNotificationState } from './downloadNotification.state';

export const selectDownloads = (state: {
  downloadNotification: DownloadNotificationState;
}) => state.downloadNotification.downloads;
